module.exports = __webpack_public_path__ + "static/media/train_54.dee5caa8.jpg";